import React, { useRef, useState, useEffect } from 'react';

import { Dialog } from '@headlessui/react';

export default function CustomeVideoReview(props) {

    const MAX_DURATION = 30 * 1000;

    const [recording, setRecording] = useState(false);
    const [videoURL, setVideoURL] = useState(null);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [stream, setStream] = useState(null);
    const [recordingTime, setRecordingTime] = useState(0);
    const videoRef = useRef();
    const previewRef = useRef();
    const chunks = useRef([]);
    const timeoutRef = useRef(null);
    const intervalRef = useRef(null);

    const startCamera = async () => {
        const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        setStream(mediaStream);
        videoRef.current.srcObject = mediaStream;
    };

    const stopCamera = () => {
        stream?.getTracks().forEach(track => track.stop());
        setStream(null);
    };

    const startRecording = () => {
        const recorder = new MediaRecorder(stream, {
            mimeType: 'video/webm; codecs=vp9'
        });
        setMediaRecorder(recorder);
        chunks.current = [];
        setRecordingTime(0);
        recorder.ondataavailable = (e) => chunks.current.push(e.data);
        recorder.onstop = () => {
            const blob = new Blob(chunks.current, { type: 'video/webm' });
            const url = URL.createObjectURL(blob);
            setVideoURL(url);
        };
        recorder.start();
        setRecording(true);

        intervalRef.current = setInterval(() => {
            setRecordingTime(prev => {
                if (prev + 1 >= 30) clearInterval(intervalRef.current);
                return prev + 1;
            });
        }, 1000);

        timeoutRef.current = setTimeout(() => stopRecording(), MAX_DURATION);
    };

    const stopRecording = () => {
        if (mediaRecorder?.state !== 'inactive') {
            mediaRecorder?.stop();
        }
        setRecording(false);
        clearTimeout(timeoutRef.current);
        clearInterval(intervalRef.current);
    };

    const handleRetake = () => {
        URL.revokeObjectURL(videoURL);
        setVideoURL(null);
        startRecording();
    };

    const handleSubmit = () => {
        URL.revokeObjectURL(videoURL);
        setVideoURL(null);
        stopCamera();
        props.onSubmit();
        // You can upload or process the video blob here
    };

    useEffect(() => {
        if (props.open) {
            startCamera();
        } else {
            stopCamera();
            clearInterval(intervalRef.current);
        }
        return () => {
            stopCamera();
            clearInterval(intervalRef.current);
        };
    }, [props.open]);

    return (
        <Dialog open={props.open} onClose={() => { props.setOpen(false) }} className='overflow-y-auto overflow-x-hidden z-[100] w-full min-h-screen fixed top-0 left-0 bg-black bg-opacity-70 flex items-center justify-center'>
            <div className="w-[96%] md:w-[40%] p-2 bg-white rounded-2xl shadow-xl">
                {!videoURL ? (
                    <div className="flex flex-col items-center space-y-2">
                        <video ref={videoRef} autoPlay muted playsInline className="w-full rounded-xl border shadow-md" />
                        {recording && (
                            <p className="text-sm text-gray-700">Recording: {recordingTime}s</p>
                        )}
                        {!recording ? (
                            <button onClick={startRecording} className="bg-green-600 hover:bg-green-700 w-[200px] rounded-md text-white text-sm py-2">Start Recording</button>
                        ) : (
                            <button onClick={stopRecording} className="bg-red-600 hover:bg-red-700 w-[200px] rounded-md text-white text-sm py-2">Stop Recording</button>
                        )}
                        <p className="text-xs text-gray-500">Max duration: 30 seconds</p>
                    </div>
                ) : (
                    <div className="flex flex-col items-center space-y-4">
                        <video ref={previewRef} src={videoURL} controls className="w-full rounded-xl border shadow-md" />
                        <div className="flex gap-4 w-full">
                            <button onClick={handleRetake} className="bg-yellow-500 hover:bg-yellow-600 w-1/2 rounded-md text-white text-sm py-2">Retake</button>
                            <button onClick={handleSubmit} className="bg-blue-600 hover:bg-blue-700 w-1/2 rounded-md text-white text-sm py-2">Submit</button>
                        </div>
                    </div>
                )}
            </div>
        </Dialog>
    )
}
